import React, { useRef } from 'react';
import '../../Styles/domain-details.css';

/** Guarantees a unique SVG gradient id per rendered instance. */
let gradientSeq = 0;

interface AgentHawkLabelProps {
  /** Text rendered next to the sparkle glyph. */
  text?: string;
  /** Icon edge length in pixels. */
  iconSize?: number;
}

/**
 * Agent Hawk brand label: a sparkle (AI) glyph plus gradient text, both using
 * the Agent Hawk palette (blue-700 -> violet-700 -> fuchsia-700) so every entry
 * point into Agent Hawk looks the same. Animation lives in the
 * `.agent-hawk-tab` rules in domain-details.css.
 */
export const AgentHawkLabel = ({ text = 'Agent Hawk', iconSize = 22 }: AgentHawkLabelProps) => {
  const gradientId = useRef(`agentHawkGradient-${++gradientSeq}`).current;

  return (
    <span className="agent-hawk-tab">
      <svg
        className="agent-hawk-tab__icon"
        width={iconSize}
        height={iconSize}
        viewBox="0 0 24 24"
        aria-hidden="true"
        focusable="false"
      >
        <defs>
          <linearGradient id={gradientId} x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#1d4ed8" />
            <stop offset="50%" stopColor="#6d28d9" />
            <stop offset="100%" stopColor="#a21caf" />
          </linearGradient>
        </defs>
        <path
          fill={`url(#${gradientId})`}
          d="M11 2.5l1.75 4.75L17.5 9l-4.75 1.75L11 15.5l-1.75-4.75L4.5 9l4.75-1.75L11 2.5z"
        />
        <path
          fill={`url(#${gradientId})`}
          d="M18 14l.9 2.35L21.25 17.25l-2.35.9L18 20.5l-.9-2.35-2.35-.9 2.35-.9L18 14z"
        />
      </svg>
      <span className="agent-hawk-tab__text">{text}</span>
    </span>
  );
};
